import React from "react";

import britishRedCrossSvg from "../../../assets/new-icons/medical-translation/british-red-cross.svg";
import johnsonjohnsonSvg from "../../../assets/new-icons/medical-translation/johnson-johnson.svg";
import medtronicSvg from "../../../assets/new-icons/medical-translation/medtronic.svg";
import m3Svg from "../../../assets/new-icons/medical-translation/3m.svg";

function HealthCare({ BackgroundCol, heading, para }) {
  return (
    <div
      className={`${
        BackgroundCol ? BackgroundCol : "bg-darkBlue"
      } flex items-center justify-center md:py-36 py-32`}
    >
      <div className="flex justify-center flex-col items-center w-11/12 xl:w-7/12 max-w-screen-2xl">
        <h2 className="leading-relaxed md:text-4xl mb-12 text-3xl font-secondary text-center md:w-10/12 text-white font-bold">
          {heading
            ? heading
            : "Medical translation services trusted by healthcare companies worldwide"}
        </h2>
        <p className="text-darkMist text-center leading-relaxed md:px-0 px-4">
          {" "}
          {para
            ? para
            : "At Tomedes, our medical translation services are trusted by healthcare companies worldwide, like the Johnson & Johnson and the British Red Cross. We put the utmost care in our medical translations, so you can better serve your patients. Why not join our satisfied clients today?"}
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 xl:w-[120%] 2xl:w-full w-full pt-6 mt-8 place-items-center">
          <img
            className="mt-5 md:mt-0 w-28"
            src={britishRedCrossSvg}
            alt="british-red-cross"
          />
          <img
            className="mt-5 md:mt-0 md:w-36 w-28"
            src={johnsonjohnsonSvg}
            alt="johnson-johnson"
          />
          <img
            className="mt-5 md:mt-0 w-28"
            src={medtronicSvg}
            alt="medtronic"
          />
          <img className="mt-5 md:mt-0 w-28" src={m3Svg} alt="3M" />
        </div>
      </div>
    </div>
  );
}

export default HealthCare;
